import React from "react";

import { PluginsFree } from "../components/plugins";

const FreeContent = ({ ...delegated }) => {
  return <PluginsFree {...delegated} />;
};

export { FreeContent };
